// Utility to handle authentication redirects
export const redirectService = {
  // Store the intended action and redirect info
  setRedirectIntent(intent) {
    localStorage.setItem('authRedirectIntent', JSON.stringify(intent));
  },

  // Get and clear the redirect intent
  getAndClearRedirectIntent() {
    const intent = localStorage.getItem('authRedirectIntent');
    localStorage.removeItem('authRedirectIntent');
    return intent ? JSON.parse(intent) : null;
  },

  // Clear redirect intent without returning it
  clearRedirectIntent() {
    localStorage.removeItem('authRedirectIntent');
  },

  // Create redirect URL with return parameter
  createAuthUrl(authType, returnTo, action) {
    const params = new URLSearchParams();
    if (returnTo) params.set('returnTo', returnTo);
    if (action) params.set('action', action);
    
    return `/${authType}?${params.toString()}`;
  },

  // Parse redirect parameters from URL
  parseRedirectParams() {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      returnTo: urlParams.get('returnTo'),
      action: urlParams.get('action')
    };
  }
};
